var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "sticky-top"
  }, [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.moduleConfig.page_title,
      "page-image": _vm.moduleConfig.page_image,
      "page-kv-image": _vm.moduleConfig.page_kv_image,
      "header-section": _vm.moduleConfig.header_section
    }
  }), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel__col"
  }, [_c('div', {
    staticClass: "panel__name"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "panel__value"
  }, [_vm._v(_vm._s(_vm.vouchers))])])])], 1), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }